import { lazy } from 'react';
import { DialogComponent } from '@lingoda/dialogs';
import { GenericInfoMessageDialog } from '@lingoda/ui';

const BookingBlockedByPauseDialog = lazy(() => import('./components/BookingBlockedByPauseDialog'));
const BookingBlockedBySubsExpiryDialog = lazy(
    () => import('@lingoda/student-booking/components/dialogs/BookingBlockedBySubsExpiryDialog'),
);
const CancelClassDialog = lazy(() => import('./components/CancelClassDialog'));
const ClassReviewDialog = lazy(() => import('./components/ClassReviewDialog'));
const ConfirmBookingDialog = lazy(() => import('./components/ConfirmBookingDialog'));
const DeletePaymentMethodDialog = lazy(() => import('./components/DeletePaymentMethodDialog'));
const NoCreditsDialog = lazy(() => import('./components/NoCreditsDialog'));
const PrivateClassDialog = lazy(() => import('./components/PrivateClassDialog'));
const ResumeCourseDialog = lazy(() => import('./components/ResumeCourseDialog'));
const RolloverSuccessDialog = lazy(() => import('./components/RolloverSuccessDialog'));
const SetGoalDialogWeeklyClasses = lazy(
    () =>
        import('@lingoda/student-achievements/components/SetGoalDialog/SetGoalDialogWeeklyClasses'),
);
const SetGoalDialogWeeklyWords = lazy(
    () => import('@lingoda/student-achievements/components/SetGoalDialog/SetGoalDialogWeeklyWords'),
);
const GoalAchievedCelebrationDialog = lazy(
    () => import('@lingoda/student-achievements/components/GoalAchievedCelebrationDialog'),
);
const YearlyRecapDialog = lazy(
    () => import('@lingoda/student-yearly-recap/components/RecapDialog'),
);
const AppLanguageDialog = lazy(() => import('@lingoda/preferences/components/AppLanguageDialog'));
const SubscribeUnlockDialog = lazy(
    () => import('@lingoda/subscriptions/components/SubscribeUnlockDialog'),
);
const UpdatePaymentMethodDialog = lazy(() => import('./components/UpdatePaymentMethodDialog'));
const SelfLearningLimitAccessDialog = lazy(
    () => import('./components/SelfLearningLimitAccessDialog'),
);
const AchievementDialog = lazy(
    () => import('@lingoda/student-achievements/components/AchievementDialog'),
);
const OnboardingChecklistDialog = lazy(
    () =>
        import(
            '@lingoda/student-achievements/components/OnboardingChecklistOld/OnboardingChecklistDialog'
        ),
);
const ConfirmCalendarDisconnectDialog = lazy(
    () => import('@lingoda/calendar-connection/components/dialogs/ConfirmDisconnectDialog'),
);
const ConnectCalendarDialog = lazy(
    () => import('@lingoda/calendar-connection/components/dialogs/ConnectCalendarDialog'),
);
const PostFFreeTrialDialog = lazy(
    () => import('@lingoda/student-f-free-trial/components/PostFFreeTrialDialog'),
);
const FFreeTrialWelcomeDialog = lazy(
    () => import('@lingoda/student-f-free-trial/components/WelcomeDialog'),
);
const FFreeTrialInformDialog = lazy(
    () => import('@lingoda/student-f-free-trial/components/InformDialog'),
);
const AddPaymentMethodDialog = lazy(
    () => import('@lingoda/student-booking/components/AddPaymentMethodDialog'),
);
const LearningGoalsDialog = lazy(
    () => import('@lingoda/student-settings/components/LearningGoalsDialog'),
);
const DeleteLearningGoalOrNeedsConfirmationDialog = lazy(
    () => import('@lingoda/student-settings/components/DeleteConfirmationDialog'),
);
const AddStudentLanguageSpokenDialog = lazy(
    () =>
        import(
            '@lingoda/student-settings/components/languagesYouSpeakDialogs/AddStudentLanguagesYouSpeakDialog'
        ),
);
const EditStudentLanguageSpokenDialog = lazy(
    () =>
        import(
            '@lingoda/student-settings/components/languagesYouSpeakDialogs/EditStudentLanguagesYouSpeakDialog'
        ),
);
const DeleteStudentLanguageSpokenDialog = lazy(
    () =>
        import(
            '@lingoda/student-settings/components/languagesYouSpeakDialogs/DeleteStudentLanguagesYouSpeakDialog'
        ),
);
const LearningNeedsDialog = lazy(
    () => import('@lingoda/student-settings/components/LearningNeedsDialog'),
);

export const dialogsMap: { [key in DialogComponent]?: unknown } = {
    [DialogComponent.GenericInfoMessageDialog]: GenericInfoMessageDialog,
    [DialogComponent.BookingBlockedByPause]: BookingBlockedByPauseDialog,
    [DialogComponent.BookingBlockedBySubsExpiry]: BookingBlockedBySubsExpiryDialog,
    [DialogComponent.CancelClass]: CancelClassDialog,
    [DialogComponent.ClassReview]: ClassReviewDialog,
    [DialogComponent.ConfirmBooking]: ConfirmBookingDialog,
    [DialogComponent.DeletePaymentMethod]: DeletePaymentMethodDialog,
    [DialogComponent.NoCredits]: NoCreditsDialog,
    [DialogComponent.PrivateClass]: PrivateClassDialog,
    [DialogComponent.ResumeCourse]: ResumeCourseDialog,
    [DialogComponent.RolloverSuccessDialog]: RolloverSuccessDialog,
    [DialogComponent.SubscribeUnlockDialog]: SubscribeUnlockDialog,
    [DialogComponent.UpdatePaymentMethod]: UpdatePaymentMethodDialog,
    [DialogComponent.SelfLearningLimitAccess]: SelfLearningLimitAccessDialog,
    [DialogComponent.SetGoalWeeklyClasses]: SetGoalDialogWeeklyClasses,
    [DialogComponent.SetGoalWeeklyWords]: SetGoalDialogWeeklyWords,
    [DialogComponent.GoalAchievedCelebration]: GoalAchievedCelebrationDialog,
    [DialogComponent.Achievement]: AchievementDialog,
    [DialogComponent.AppLanguageDialog]: AppLanguageDialog,
    [DialogComponent.OnboardingChecklist]: OnboardingChecklistDialog,
    [DialogComponent.YearlyRecapDialog]: YearlyRecapDialog,
    [DialogComponent.ConfirmCalendarDisconnectDialog]: ConfirmCalendarDisconnectDialog,
    [DialogComponent.ConnectCalendarDialog]: ConnectCalendarDialog,
    [DialogComponent.PostFFreeTrialDialog]: PostFFreeTrialDialog,
    [DialogComponent.FFreeTrialWelcomeDialog]: FFreeTrialWelcomeDialog,
    [DialogComponent.FFreeTrialInformDialog]: FFreeTrialInformDialog,
    [DialogComponent.AddPaymentMethod]: AddPaymentMethodDialog,
    [DialogComponent.LearningGoalsDialog]: LearningGoalsDialog,
    [DialogComponent.DeleteLearningGoalOrNeedsConfirmationDialog]:
        DeleteLearningGoalOrNeedsConfirmationDialog,
    [DialogComponent.AddStudentLanguageSpokenDialog]: AddStudentLanguageSpokenDialog,
    [DialogComponent.EditStudentLanguageSpokenDialog]: EditStudentLanguageSpokenDialog,
    [DialogComponent.DeleteStudentLanguageSpokenDialog]: DeleteStudentLanguageSpokenDialog,
    [DialogComponent.LearningNeedsDialog]: LearningNeedsDialog,
};
